import React from "react";
import ReactDOM from "react-dom";
import Overlay from "../Utils/Overlay";

const AuthModal = ({ children, onClose }) =>
  ReactDOM.createPortal(
    <div className="confirmation-modal">
      <Overlay darkTheme handleOnClick={onClose} />
      {children}
    </div>,
    document.body
  );

export default AuthModal;
